import { Grid, Typography } from "@mui/material";

const SlideSectionTitle = ({ children, size, sx }) => {
  return (
    <Grid size={size || 12} sx={sx}>
      <Typography variant="h2" size={size}>
        {children}
      </Typography>
    </Grid>
  );
};

export default SlideSectionTitle;
